import { Component } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { DevExtremeModule } from 'devextreme-angular';

declare var jQuery: any;

@Component({
    selector: 'blank',
    templateUrl: 'blankLayout.template.html',
    imports: [DevExtremeModule, RouterOutlet],
    standalone: true,
})
export class BlankLayoutComponent {
    ngAfterViewInit() {
        jQuery('body').addClass('gray-bg');
    }

    ngOnDestroy() {
        jQuery('body').removeClass('gray-bg');
    }
}
